<template>
  <div>
    <div class="pa-5" style="display: flex; justify-content: space-between;; padding: 0 12px">
      <div class="ml-5">
        <div>
            <v-menu
                bottom
                right
                offset-y
                :internal-activator="true"
                content-class="no-contain overflow-visible"
                :close-on-content-click="false"
                v-model="openMenu"
            >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn style="padding: 0px 25px !important; margin-right: 10px;"
                         color="primary" dark v-on="on">
                    <span>Tìm kiếm</span>
                    <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-card
                    width="400px"
                    outlined
                    class="ma-0"
                >
                  <v-row class="px-5 py-5 mt-3">
                    <v-col
                        class="py-0"
                        cols="12">
                      <v-text-field
                          placeholder="Nhập tên, máy lẻ"
                          label="Tìm kiếm theo tên, máy lẻ"
                          clearable
                          @keyup.enter="searchUser"
                          v-model="fillter.keyword"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="px-5 pb-5">
                    <v-col class="py-0" cols="12">
                      <v-autocomplete
                          v-model="fillter.code"
                          :items="listBrandsData"
                          item-text="name"
                          item-value="code"
                          placeholder="Chọn kịch bản "
                          label="Tìm kịch bản "
                          clearable
                          hide-details
                      />
                    </v-col>
                  </v-row>
                  <div class="text-center mb-4">
                    <v-btn
                        class="primary mx-0"
                        @click="searchUser"
                    >
                      <v-icon>mdi-magnify</v-icon>Tìm kiếm
                    </v-btn>
                  </div>
                </v-card>
            </v-menu>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end; padding: 0 12px">
        <div class="text-right mb-1 mt-2">
          {{ showContactsIndex() }}
          <v-btn
            small
            class="pagination-btn-left ml-4"
            @click="function() {currentPage--}"
            :disabled="currentPage == 1"
          >
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn
            small
            class="pagination-btn-right"
            @click="function() {currentPage++}"
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
        <div style="width: 35px">
          <v-text-field
            class="pt-0"
            v-model="currentPage"
            min="1"
            step="1"
            type="number"
          >
          </v-text-field>
        </div>
      </div>
    </div>
    <div class="contact-table pb-5 mx-9" id="contact-table">
      <v-simple-table
        class="table-layout table-contact table-fixed "
        style="border: 0;"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="font-weight-regular --module-title scroll-layout-left name-sale"
                rowspan="2"
                style="left: 0px"
              >
                Tên sale
              </th>
              <th
                class="font-weight-regular --module-title scroll-layout-left name-script"
                rowspan="2"
                style="left: 300px"
              >
                Kịch bản
              </th>
              <template v-for="(module, index) in groups">
                <th
                  class="font-weight-regular --module-title"
                  :key="'typeTS-' + index"
                  colspan="2"
                >
                  {{ module.name }}
                </th>
              </template>
            </tr>
            <tr>
              <template v-for="(module, index) in groups">
                <th
                  class="font-weight-regular --module-title"
                  :key="'typeKB-' + index"
                >
                  Tổng đài
                </th>
                <th
                  class="font-weight-regular --module-title"
                  :key="'typeML-' + index"
                >
                  Máy lẻ
                </th>
              </template>
              <!-- <template v-for="(module, index) in groups">
              <th
                class="font-weight-regular --module-title"
                :key="'type-' + index"
              >

              </th>
            </template> -->
            </tr>
          </thead>
          <tbody v-if="userScripts.length < 1">
          <tr>
            <td colspan="12" class="scroll-layout-left">
              <common-no-result />
            </td>
          </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(item, index) in userScripts" :key="index">
              <td
                class="font-weight-regular --module-title scroll-layout-left name-sale"
                style="min-width: 5rem;left: 0px"
              >
                {{ item.fullName }}
                <div class="delete-script-sale">
                  <v-icon color="#919090" @click="deleteScriptSale(item.userId)">mdi-delete</v-icon>
                </div>
              </td>
              <td
                class="font-weight-regular --module-title scroll-layout-left px-4 pb-2 pt-3"
                style="min-width: 5rem;left: 300px"
              >
                <v-autocomplete
                  :items="listBrandsData"
                  item-text="name"
                  item-value="code"
                  v-model="item.scriptCode"
                  outlined
                  dense
                  placeholder="Chọn KB"
                  solo
                  flat
                  @change="changeScriptCode(index)"
                ></v-autocomplete>
              </td>
              <template v-for="(module, index) in item.brandDetail">
                  <td :key="'typeTong-' + index">
                    <v-autocomplete
                      v-if="item.scriptCode"
                      :items="TONGDAI"
                      item-text="name"
                      item-value="id"
                      v-model="module.callcenterId"
                      dense
                      solo
                      flat
                      placeholder="Chọn tổng đài"
                      @change="module.ext = null"
                    ></v-autocomplete>
                    <span v-else>-</span>
                  </td>
                  <td :key="'typeInput-' + index">
                    <input
                    class="input-scriptCode"
                    v-if="item.scriptCode"
                        @change="
                        updateUserScript((module.ext = $event.target.value), item, module)
                    "
                        :value="module.ext"
                        type="number"
                        :placeholder="module.callcenterId ? 'Nhập máy lẻ' : ''"
                        pattern="/^-?\d+\.?\d*$/"
                        onKeyPress="if(this.value.length==10) return false;"
                        @keypress="isNumber($event)"
                        :disabled="!module.callcenterId"
                    />
                    <!-- <v-text-field
                      v-if="item.scriptCode"
                      v-model="module.ext"
                      placeholder="Chọn máy lẻ"
                      dense
                      solo
                      flat
                      :disabled="!module.callcenterId"
                      @keyup.enter="updateUserScript(item, module)"
                      @keypress="isNumber($event)"
                      type="number"
                      pattern="/^-?\d+\.?\d*$/"
                      onKeyPress="if(this.value.length==10) return false;"
                    ></v-text-field> -->
                    <span v-else>-</span>
                  </td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import RepositoryFactory from "../../repositories/RepositoryFactory";
const ScriptRepository = RepositoryFactory.get("script");
export default {
  data() {
    return {
      groups: [],
      userScripts: [],
      scripts: [],
      TONGDAI: [
        {
          id: 4,
          name: "ODS",
        },
        {
          id: 2,
          name: "Caresoft",
        },
      ],
      userScriptsBase: [],
      listBrandsData: [],
      limit: 10,
      currentPage: 1,
      fillter: {
        keyword: null,
        code: null,
      },
      openMenu: false
    };
  },
  created() {
    // this.getListKB();
    this.getListUserScripts();
  },
  watch: {
    currentPage: {
      handler(val) {
        const params = {
          page: val,
          ...this.fillter
        };
        this.getListUserScripts(params);
      },
    },
  },
  methods: {
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    },
    showContactsIndex() {
      if (this.userScripts.length > 0) {
        let maxIndex = parseInt(this.currentPage) * parseInt(this.limit);
        return maxIndex - parseInt(this.limit) + 1 + " - " + maxIndex;
      } else {
        return "0 - 0";
      }
    },
    // async getListKB() {
    //   const res = await ScriptRepository.getListKB();
    //   this.scripts = _.get(res, "data", []);
    // },
    async getListUserScripts(params) {
      const loading = this.$loading.show();
      const res = await ScriptRepository.getListUserScripts(params);
      const listBrands = await ScriptRepository.getListBrands();
      loading.hide();
      this.listBrandsData = _.get(listBrands, "data", []);
      const groups = _.get(res, "data.groups", []);
      this.groups = groups;

      const newData = _.get(res, "data.userScripts", []).map((s) => {
        const newBrandDetail = [];
        let findInListBrands = _.find(groups, ["id", s.scriptCode]);
        groups.forEach((r, index) => {
          const singelBrandDetail = _.find(s.brandDetail, [
            "groupId",
            r.id,
          ]);
          if (!singelBrandDetail) {
            newBrandDetail[index] = {
              brandnameCode: r.brandnameCode,
              callcenterId: null,
              ext: null,
              extPassword: null,
              groupId: r.id
            };
          } else {
            newBrandDetail[index] = singelBrandDetail;
          }
        });
        s.brandDetail = newBrandDetail;
        s.brandDetail.forEach((br, index) => {
          if (
            s.scriptCode &&
            findInListBrands &&
            !_.find(findInListBrands.groups, ["code", br.brandnameCode]) &&
            br.brandnameCode
          ) {
            br.disabled = true;
          }
        });
        return s;
      });
      this.userScripts = newData;

      this.userScriptsBase = newData;
    },
    async updateUserScript(text, item, module) {
    if(module.ext == '') {return}
      const id = item.userId;
      const params = {
        scriptCode: item.scriptCode,
        brandnameCode: module.brandnameCode,
        callcenterId: module.callcenterId,
        ext: module.ext,
        groupId: module.groupId
      };
      const res = await ScriptRepository.updateUserScripts(id, params);
      if (res.error) {
        this.$swal({
          type: "error",
          title: "Lỗi !",
        });
      }
    },
    async changeScriptCode(index) {
      let userNew = this.groups.map((s) => {
        return {
          brandnameCode: s.brandnameCode,
          callcenterId: null,
          ext: null,
          extPassword: null,
          groupId: s.id,
        };
      });
      this.userScripts[index].brandDetail = userNew;
      let findInListBrands = _.find(this.listBrandsData, [
        "code",
        this.userScriptsBase[index].scriptCode,
      ]);
      let newBrandDetail = this.userScriptsBase[index].brandDetail.map((br) => {
        if (
          this.userScriptsBase[index].scriptCode &&
          findInListBrands &&
          !_.find(findInListBrands.groups, ["code", br.brandnameCode]) &&
          br.brandnameCode
        ) {
          br.disabled = true;
        }
        return br;
      });
      this.userScripts[index].brandDetail = newBrandDetail;
    },
    searchUser() {
      const params = this.fillter
      params.keyword = params.keyword?.trim();
      this.getListUserScripts(params);
      this.openMenu = false
    },
    async deleteScriptSale(userId) {
      this.$swal({
          title: 'Bạn có chắc chắn?',
          text: `Muốn xóa kịch bản ` + name,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Xóa',
          cancelButtonText: 'Không'
        }).then(async (result) => {
          if (result.value) {
            const res = await ScriptRepository.deleteScriptSale(userId)
              if (res.success) {
              this.$swal({
                type: "success",
                title: "Xóa thành công!",
                timer: 1500,
              });
              const params = {
                page: this.currentPage,
                ...this.fillter
              };
            this.getListUserScripts(params);
            }else {
              this.$swal({
                type: "error",
                title: "Lỗi !",
                timer: 1500,
                text: _.get(res, "message", ""),
              })
            }
          }
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.font-weight-regular {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  cursor: pointer;
}
.--module-title {
  font-weight: bold !important;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}
.scroll-layout-left {
  position: sticky;
}
.contact-table th.name-sale {
  min-width: 300px;
}
.contact-table th.name-script {
  min-width: 200px;
}
thead tr th {
  background: #f2f2f2 !important;
}
::v-deep .v-text-field__details {
  display: none;
}
.contact-table .table-layout tbody tr:hover {
  background: white !important;
}
.contact-table .table-layout tbody tr td:hover {
  background: #f2f2f2 !important;
}
input.input-scriptCode {
    background: white;
    height: 37px;
    width: 108px;
    padding-left: 10px;
    border-radius: 4px;
    font-size: 14px;
    margin-bottom: 3px;
    font-weight: 400;
    color: #575757;
    outline: none;
}
input[type=number] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.delete-script-sale {
  position: absolute;
  right: 16px;
  top: 22px;
}

</style>
